import React from 'react';
import { ConnectedConfiguratorScreen } from '@configuratorware/configurator-frontendgui/App/Screens/Configurator/Screen';
import ThemeProvider from './ThemeProvider';
import CreatorLayout from './Layout';
import CustomProgress from '../Components/CustomProgress/CustomProgress';

const ConfiguratorScreen = (props) => {
  return (
    <ConnectedConfiguratorScreen
      {...props}
      CreatorScreen={CreatorLayout}
      ThemeProvider={ThemeProvider}
      selectedConfigurationMode={'creator'}
    />
  );
};

export default ConfiguratorScreen;
